jQuery(document).ready(function ($) {
  $('.custom-select').each(function () {
      var $this = $(this),
      numberOfOptions = $(this).children('option').length;

      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');
      $styledSelect.text($this.children('option').eq(0).text());

      var $list = $('<ul />', {
      'class': 'select-options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val()
      }).appendTo($list);
      }

      var $listItems = $list.children('li');

      $styledSelect.click(function (e) {
      e.stopPropagation();
      $('div.select-styled.active').not(this).each(function () {
          $(this).removeClass('active').next('ul.select-options').hide();
      });
      $(this).toggleClass('active').next('ul.select-options').toggle();
      });

      $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $list.hide();
      //console.log($this.val());
      });

      $(document).click(function () {
      $styledSelect.removeClass('active');
      $list.hide();
      });

  });

  // New account management
  $('.account-sidebar a[href="#"]').on('click', function (e) {
    e.preventDefault();
    var tab_href = $(this).data('href');
    $('.tab-content').removeClass('opened');
    $('.tab-content[data-tab="' + tab_href + '"]').addClass('opened');
    $('.account-sidebar a').removeClass('active');
    $(this).addClass('active');
    $('.account-header .current_tab').text($(this).text());
  })

  // Mobile account sidebar action
  $('.mobile-account_sidebar .select-options li').on('touchend', function () {
    var selected_dropdown = $(this).attr('rel');

    $('.tab-content').removeClass('opened');
    if (selected_dropdown.indexOf('Personal Data') > -1) {
      $('.tab-content[data-tab="personal_data"]').addClass('opened');
    } else if (selected_dropdown.indexOf('My Orders') > -1) {
      $('.tab-content[data-tab="my_orders"]').addClass('opened');
    }
  })

  // Add new address
  $('.new_address').on('click', function () {
    $('.add_address').toggle();
  })

  // Edit address
    $('.account-addresses .edit_button').on('click', function () {
      var edit_formId = '#edit_address_' + $(this).data('id');
      $(edit_formId).show();
    })

  // Change account email and password
    $('.sidebar-button[data-target]').on('click', function () {
      $('.tab-content.opened').find('.sidebar-card').hide();
      $('.tab-content.opened').find('.sidebar-card_title').hide();
      var target_class = '.' + $(this).data('target');
      $(target_class).show();
    })
  // Cancel button
    $('.sidebar-card .action_cancel').on('click', function () {
      $('.tab-content.opened').find('.sidebar-card_title').show();
      $(this).parents('.sidebar-card').hide();
      $(this).parents('.tab-content').find('.sidebar-card:not(".hidden")').show();
    })

  // Uk popup
  var uk_popup_flag = Cookies.get('uk-popup');
  var it_popup_flag = Cookies.get('it-popup');
  // $.ajax({
  //   url: 'https://freegeoip.app/json/',
  //   dataType: 'json'
  // }).done(function(response){
  //   if( response.country_code != 'US' ){
  //     $('.menu_tv_link').hide();
  //     if( it_popup_flag != 'true' ){
  //       $.fancybox.open({
  //         src  : '#it_popup',
  //         type : 'inline',
  //         buttons: ["close"],
  //         opts : {
  //           afterShow : function( instance, current ) {
  //             console.info( 'done!' );
  //             Cookies.set('it-popup', true);
  //           }
  //         }
  //       });
  //     }
  //     // Hide Versabox add to cart for outside of US
  //       $('.product-name--strong-versabox .purchase-details').hide();
  //   }
  //   // if( uk_popup_flag != 'true' ){
  //   //   if( response.country_code == 'GB' ){
  //   //     $.fancybox.open({
  //   //       src  : '#uk_popup',
  //   //       type : 'inline',
  //   //       buttons: ["close"],
  //   //       opts : {
  //   //         afterShow : function( instance, current ) {
  //   //           console.info( 'done!' );
  //   //           Cookies.set('uk-popup', true);
  //   //         }
  //   //       }
  //   //     });
  //   //   }
  //   // }
  //   if( response.country_code == 'MX' ){
  //     $.fancybox.open({
  //       src  : '#mexico_popup',
  //       type : 'inline',
  //       buttons: ["close"],
  //       opts : {
  //         afterShow : function( instance, current ) {
  //           console.info( 'done!' );
  //         }
  //       }
  //     });
  //   }
  // })

  // // Count down timer
  // function makeTimer() {
  //   //		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
  //   var endTime = new Date("7 September 2020 23:59:00 GMT-05:00");			
  //     endTime = (Date.parse(endTime) / 1000);

  //     var now = new Date();
  //     now = (Date.parse(now) / 1000);

  //     var timeLeft = endTime - now;

  //     var days = Math.floor(timeLeft / 86400); 
  //     var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
  //     var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
  //     var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

  //     if (hours < "10") { hours = "0" + hours; }
  //     if (minutes < "10") { minutes = "0" + minutes; }
  //     if (seconds < "10") { seconds = "0" + seconds; }

  //     $(".days").html(days + "<span>Days</span>");
  //     $(".hours").html(hours + "<span>Hours</span>");
  //     $(".minutes").html(minutes + "<span>Minutes</span>");
  //     $(".seconds").html(seconds + "<span>Seconds</span>");		
  // }

  // setInterval(function() { makeTimer(); }, 1000);

  // Megamenu bg overlay
  $('.mega-menu-parent').on('mouseenter', function(){
    $('#background_overlay').fadeIn();
  })
  $('.mega-menu-parent').on('mouseleave', function(){
    $('#background_overlay').fadeOut();
  })

  window.dispatchEvent(new Event('resize'));

  // #Cart reserve 12 minutes timer
  var timer2 = "12:01";
  var interval = setInterval(function() {
    var timer = timer2.split(':');
    //by parsing integer, I avoid all extra string processing
    var minutes = parseInt(timer[0], 10);
    var seconds = parseInt(timer[1], 10);
    --seconds;
    minutes = (seconds < 0) ? --minutes : minutes;
    if (minutes < 0) clearInterval(interval);
    seconds = (seconds < 0) ? 59 : seconds;
    seconds = (seconds < 10) ? '0' + seconds : seconds;
    //minutes = (minutes < 10) ?  minutes : minutes;
    $('.cart_minutes').html(minutes);
    $('.cart_seconds').html(seconds);
    timer2 = minutes + ':' + seconds;
  }, 1000);

  // Hide TV add to cart for outside of US
  // if($('body').hasClass('product-samsung-tv')){
  //   $.ajax({
  //     url: 'https://freegeoip.app/json/',
  //     dataType: 'json'
  //   }).done(function(response){
  //     if( response.country_code != 'US' ){
  //       var tv_atc = $('.tv-form .add_to_cart');
  //       tv_atc.prop('disabled', true);
  //       tv_atc.find('.tooltip').html("TVs cannot be shipped to outside the U.S.");
  //       // tv_atc.find('span.text').html('')
  //     }
  //   })
  // }

    $.ajax({
      url: '/browsing_context_suggestions.json',
      dataType: 'json'
    }).done(function(response){
      if( response.detected_values.country.handle == 'US' || response.detected_values.country.handle == 'AU' ){
        $('.promo-banner').show();
        document.querySelector('body')?.classList?.add('promo-banner--show');
      }
    })

  // Show cart popup alert if cart has Frame
  // if($('.cart_popup-alert').length){
  //   $.fancybox.open($('.cart_popup-alert'));
  // }

  $(document).on('click', '.btn_no', function(e){
    e.preventDefault();
    $('.yes-wrapper').hide();
    $('.no-wrapper').show();
  })

  // Pick up size notification

  $('.pickup_size_form').on('click','.add_to_cart',function(e){
    e.preventDefault();
    
    var sizewrap = $('.swatch.clearfix.model_year').length;
    var sizeelements = $('.swatch.clearfix.model_year input:radio').length;
    var checkedelements = $('.swatch.clearfix.model_year input:radio:checked').length;
    
    if(sizewrap && (sizeelements > 1)){
        var size_class = $('.swatch.clearfix.model_year.sizenotselected').length;
        var $pick_msg = $('.pickup_err_msg');	  
    if(size_class){
        $pick_msg.slideDown();
        $('.swatch.clearfix.model_year.sizenotselected').removeClass('sizenotselected');
        return false;
    } else {
        $('.pickup_size_form').submit();  
        $pick_msg.slideUp();
    }
    } else if(sizewrap && (sizeelements == 1)){
        $('.swatch.clearfix.size input:radio').prop("checked", true);
        $('.pickup_size_form form').submit();  
        $('.pickup_err_msg').slideUp();
    } else {
        $('.pickup_size_form form').submit();
    }
  });

  $('.swatch.clearfix.model_year').click(function(){
      $('.swatch.clearfix.model_year').removeClass('sizenotselected');
      $('.pickup_err_msg').slideUp();
  });
  $('.swatch.clearfix.model_year').addClass('sizenotselected');

  // Show popup on Antique white frame PDP
  if($('.product-name--antique-white-samsung-frame').length){
    setTimeout(function(){
      $.fancybox.open($('#antiquie_popup'));
    }, 20000);
  }

  // BFCM Footer
  // $('.BF_toggle').on('click', function(e){
  //   e.preventDefault();
  //   Cookies.set('bfcm_popup', false);
  //   if($(this).hasClass('active')){
  //     $( ".BF_Footer" ).animate({
  //       bottom: '-280px'
  //     },300, "linear")
  //     $(this).removeClass('active');
  //   }
  //   else{
  //     $( ".BF_Footer" ).animate({
  //       bottom: '0'
  //     },300, "linear")
  //     $(this).addClass('active');
  //   }
  // })

  // if(Cookies.get('bfcm_popup') == 'false'){
  //   $('.BF_Footer').addClass('closed');
  //   $('.BF_toggle').removeClass('active');
  // }

  // About us - Timeline carousel
  $('.timeline-item span').on('click', function(e){
    e.preventDefault();
    let target = $(this).data('target');
    $('.timeline-item').removeClass('active');
    $(this).parent().addClass('active');
    $('.timelines-wrapper .featured-link--section').hide();
    $(target).fadeIn();
  })

  // account login check
  $('.login-btn').on('click', function(e){
    e.preventDefault();

    let customer_email = $('#customer_email').val();
    let url = "http://decoapi.framemytv.com/api/fmtv/customer/is-reseller/?email=" + customer_email;
    $.ajax({
      url: url
    }).done(function(response) {

      if(response.isReseller == true ){
        alert('Hello! It looks like your username is registered as an authorized reseller with Frame My TV. To place a dealer order and to receive discounts, please login at http://framemytv.com. Please be advised that orders accidentally placed on DecoTVFrames.com cannot have pricing adjustments made and will NOT apply toward your platinum dealer qualification status.');
      }
      else{
        $('#customer_login').submit();
      }
      console.log('fantastic:', response.isReseller);
    });
  })

  // Hide freeshipping banner for customers from US territories
  $.ajax({
    url: 'https://ipinfo.io/json',
    dataType: 'json'
  }).done(function(response){
    if(response.region == 'American Samoa' || response.region == 'Guam' || response.region == 'Marshall Islands' || response.region == 'Northern Mariana Islands' || response.region == 'Palau' || response.region == 'Puerto Rico' || response.region == 'U.S. Virgin Islands' || response.region == 'Hawaii' || response.region == 'Alaska') {
      $('.promo-banner').hide();
      document.querySelector('body')?.classList?.remove('promo-banner--show');
    }
  })

  // laborday sale discount applied notification

  var is_labor = Cookies.get('labor_active');

  if(is_labor){
    $('.discount_applied_alert').hide();
  }
  else{
    $('.discount_applied_alert').slideDown();
  }
  if($('.discount_applied_alert').length > 0)
    Cookies.set('labor_active', true);

  // Custom discounted box / show discounted price
  if($('.custom_discount_info_plp').length > 0){
    var discount_code_cookie = $.cookie("discount_code");
    $('.custom_discount_info_plp').each(function(index){
      let discount_code = $(this).data('code');
      if(discount_code_cookie == discount_code){
        $(this).next().addClass('active');
      }
    })
  }
})
/* Enavi Sticky ATC */
document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth <= 767) {
        const currentPriceElement = document.querySelector('.current_price');
        const currentSoldoutElement = document.querySelector('.sold_out');
        const defaultAtc = document.querySelector('#AddToCart');
        const currentPriceEnavi = document.querySelectorAll('.current_price-enavi');
        const enaviStickyAtc = document.querySelector('.enavi-sticky-atc');
        const sizeOptions = document.querySelectorAll('.size-option');
        const dropdown = document.getElementById('sticky-option-dropdown');
        const selectedValueElement = document.querySelector('.option-value-dropdown');
        if (currentPriceElement && currentPriceEnavi) {
            const updateCurrentPrice = () => {
                if (currentPriceElement.innerHTML.trim() === "") {
                    setTimeout(() => currentPriceObserver.observe(currentPriceElement, { childList: true, subtree: true }), 100);
                } else {
                  currentPriceEnavi.forEach((enaviPrice) => {
                     enaviPrice.innerHTML = currentPriceElement.innerHTML;
                  });
                }
            };

            const currentPriceObserver = new MutationObserver(updateCurrentPrice);
            currentPriceObserver.observe(currentPriceElement, { childList: true, subtree: true });
        }

        if (currentSoldoutElement && currentPriceEnavi) {
            const updateCurrentSoldout = () => {
                if (currentSoldoutElement.innerHTML.trim() === "") {
                    setTimeout(() => currentSoldoutObserver.observe(currentSoldoutElement, { childList: true, subtree: true }), 100);
                } else {
      
                  currentPriceEnavi.forEach((enaviPrice) => {
                     enaviPrice.innerHTML = currentSoldoutElement.innerHTML + ' ';
                  });
                }
            };

            const currentSoldoutObserver = new MutationObserver(updateCurrentSoldout);
            currentSoldoutObserver.observe(currentSoldoutElement, { childList: true, subtree: true });
        }

        if (defaultAtc && enaviStickyAtc) {
            const updateAtc = () => {
                if (defaultAtc.innerHTML.trim() === "") {
                    setTimeout(() => defaultAtcObserver.observe(defaultAtc, { childList: true, subtree: true }), 100);
                } else {
                    enaviStickyAtc.innerHTML = defaultAtc.innerHTML;
                    if(defaultAtc.innerHTML.includes('Sold Out') || defaultAtc.innerHTML.includes('sold out')){
                        enaviStickyAtc.setAttribute('disabled','disabled');
                    }
                    else{
                      enaviStickyAtc.removeAttribute('disabled');
                    }
                }
            };

            const defaultAtcObserver = new MutationObserver(updateAtc);
            defaultAtcObserver.observe(defaultAtc, { childList: true, subtree: true });
        }

        if (enaviStickyAtc) {
            enaviStickyAtc.addEventListener('click', function() {
                const element = document.querySelector('.product_name');
                document.querySelector('#AddToCart').classList.add('sticky-atc-clicked');
                  document.querySelector('.model_year input:checked').click();
                  setTimeout(function(){
                    document.querySelector('#AddToCart').click();
                    document.querySelector('#AddToCart').classList.remove('sticky-atc-clicked');
                  },1000)
                    const offsetTop = element.getBoundingClientRect().top + window.scrollY;
                    const threshold = 150;
                    window.scrollTo({
                        top: offsetTop - threshold,
                        behavior: 'smooth'
                    });
            });
        }

        if (sizeOptions.length > 0) {
            sizeOptions.forEach(option => {
                option.addEventListener('change', function() {
                    const selectedSize = this.getAttribute('data-size');
                    const selectedSizeElement = document.querySelector('.selected-size');
                    if (selectedSizeElement) {
                        selectedSizeElement.innerHTML = '/ ' + selectedSize;
                    }
                });
            });
        }

        function isAboveViewport(element) {
            const rect = element.getBoundingClientRect();
            return rect.top < 0;
        }

        function handleScroll() {
            const purchaseDetailsButtons = document.querySelector('.purchase-details__buttons');
            if (purchaseDetailsButtons) {
                if (isAboveViewport(purchaseDetailsButtons)) {
                    document.body.classList.add('show-sticky');
                } else {
                    document.body.classList.remove('show-sticky');
                }
            }
        }

        window.addEventListener('scroll', handleScroll);
         
      dropdown.addEventListener('change', function() {
       const selectedValue = dropdown.value;
      selectedValueElement.innerHTML = selectedValue.split('"')[0]+'"';
      document.querySelectorAll('.size-option').forEach((size) => {
        if(size.value  == selectedValue){
          size.click();
        }
      });
      });
      if (sizeOptions.length > 0) {
          sizeOptions.forEach(function(option) {
          option.addEventListener('change', function() {
              const selectedSize = this.getAttribute('data-size');
              selectedValueElement.innerHTML = selectedSize;
              dropdown.value = this.getAttribute('value');
          });
          });
      }
    }
});

/* Enavi Sticky ATC */


/* Enavi User Journey Change */
document.addEventListener("DOMContentLoaded", function() {
  var targetElement = document.querySelector('.swatch_options'); // Replace with your target element's selector
  if (targetElement) {
      document.body.addEventListener('click', function (event) {
        handleClick(event);
      });
      document.body.addEventListener('touchend', function (event) {
      handleClick(event);
  });
  function handleClick(event){
     if (event.target.classList.contains('yotpo-lightbox-product-button')) {
              event.preventDefault(); // Prevent the default action (opening the new window)
              var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
              var offsetPosition = elementPosition - 80;
              window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
              });
              document.querySelector('.yotpo-close-modal').click();
          } 
  }
      function removeOnclickAttributes(node) {
          if (node.nodeType === 1) {
              if (node.classList.contains('.yotpo-lightbox-product:not(.yotpo-hidden) yotpo-lightbox-product-button')) {
                  node.removeAttribute('onclick');
              }
              node.querySelectorAll('.yotpo-lightbox-product:not(.yotpo-hidden) .yotpo-lightbox-product-button').forEach(function (button) {
                  button.removeAttribute('onclick');
              });
          }
      }

      // MutationObserver to monitor DOM changes and remove inline onclick attributes
      var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                  removeOnclickAttributes(node);
              });
          });
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  if(window.innerWidth <= 767){
    $(document).on('touchend', function(event) {
        var $target = $(event.target);
        if ($target.hasClass('yotpo-lightbox-product-selected') || $target.hasClass('yotpo-lightbox-product-select-image')) {
            setTimeout(function() {
                var productid = $target.data('product-id');
                yotpoVariantStructure(productid, event);
            }, 500);
        } else if ($target.hasClass('yotpo-lightbox-arrows') || $target.hasClass('yotpo-icon-left-arrow-thin') || $target.hasClass('yotpo-icon-right-arrow-thin')) {
            setTimeout(function() {
                try {
                    var $product = $('.yotpo-lightbox-products-main .yotpo-lightbox-product:not(.yotpo-hidden)');
                    var productid = $product.data('product-id');
                    yotpoVariantStructure(productid, event);
                } catch (err) {
                    console.error(err);
                }
            }, 500);
        } else if ($target.hasClass('y-media-hover') || $target.hasClass('yotpo-stars') || $target.hasClass('y-hover-elements') || $target.hasClass('yotpo-hover-cta') || $target.hasClass('y-image-overlay')) {
            setTimeout(function() {
                var $product = $('.yotpo-lightbox-products-main .yotpo-lightbox-product:not(.yotpo-hidden)');
                var productid = $product.data('product-id');
                yotpoVariantStructure(productid, event);
            }, 500);
        } else if ($target.hasClass('yotpo-btn-atc')) {
            var $parentWrapper = $target.closest('.yotpo-variant-container');
            var variantId = parseInt($parentWrapper.find('.hidden-yotpo-variant').val(), 10);
            yotpoAddToCart(variantId, 1);
        }
    });
  }
  else{
        $(document).on('click', function(event) {
        var $target = $(event.target);
    
        if ($target.hasClass('yotpo-lightbox-product-selected') || $target.hasClass('yotpo-lightbox-product-select-image')) {
            setTimeout(function() {
                var productid = $target.data('product-id');
                yotpoVariantStructure(productid, event);
            }, 500);
        } else if ($target.hasClass('yotpo-lightbox-arrows') || $target.hasClass('yotpo-icon-left-arrow-thin') || $target.hasClass('yotpo-icon-right-arrow-thin')) {
            setTimeout(function() {
                try {
                    var $product = $('.yotpo-lightbox-products-main .yotpo-lightbox-product:not(.yotpo-hidden)');
                    var productid = $product.data('product-id');
                    yotpoVariantStructure(productid, event);
                } catch (err) {
                    console.error(err);
                }
            }, 500);
        } else if ($target.hasClass('y-media-hover') || $target.hasClass('yotpo-stars') || $target.hasClass('y-hover-elements') || $target.hasClass('yotpo-hover-cta') || $target.hasClass('y-image-overlay')) {
            setTimeout(function() {
                var $product = $('.yotpo-lightbox-products-main .yotpo-lightbox-product:not(.yotpo-hidden)');
                var productid = $product.data('product-id');
                yotpoVariantStructure(productid, event);
            }, 500);
        } else if ($target.hasClass('yotpo-btn-atc')) {
            var $parentWrapper = $target.closest('.yotpo-variant-container');
            var variantId = parseInt($parentWrapper.find('.hidden-yotpo-variant').val(), 10);
            yotpoAddToCart(variantId, 1);
        }
    });
  }
  document.addEventListener('change', function(event) {
    if (event.target && event.target.classList.contains('yotpo-option-dropdown')) {
        const selectedValue = event.target.value;
        const label = event.target.previousElementSibling;
        const displayedValue = selectedValue.includes('"')
            ? selectedValue.split('"')[0]+'"'
            : selectedValue;
        if (label && label.tagName === 'LABEL') {
            label.querySelector('.option-value-dropdown').textContent = displayedValue ;
        }
        const parentWrapper = event.target.closest('.yotpo-variant-container');
        const dropdowns = parentWrapper.querySelectorAll('.yotpo-option-dropdown');
        let concatenatedValues = '';
        dropdowns.forEach((dropdown, index) => {
          concatenatedValues += dropdown.value;
            if (index < dropdowns.length - 1) {
                concatenatedValues += ' / ';
            }
        });
        const variantOptions = parentWrapper.querySelectorAll('.hidden-yotpo-variant option');
        let variantAvailable = false;
        let soldout = false;
        variantOptions.forEach(option => {
          if(option.getAttribute('data-title') == concatenatedValues){
            variantAvailable = true;
            let selectedVariantId = option.getAttribute('value');
            let selectedVariantPrice = option.getAttribute('data-price');
            if(option.getAttribute('data-available') != 'true'){
              soldout = true;
            }
            parentWrapper.querySelector('.current_price-enavi').textContent = selectedVariantPrice;
            parentWrapper.querySelector('.hidden-yotpo-variant').value = selectedVariantId;
            parentWrapper.querySelector('.hidden-yotpo-variant').dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        if(!variantAvailable){
          parentWrapper.querySelector('.yotpo-btn-atc').textContent='UNAVAILABLE';
          parentWrapper.querySelector('.yotpo-btn-atc').setAttribute('disabled','disabled');
        }
        else if(soldout){
          parentWrapper.querySelector('.yotpo-btn-atc').textContent='SOLDOUT';
          parentWrapper.querySelector('.yotpo-btn-atc').setAttribute('disabled','disabled');
        }
        else{
          parentWrapper.querySelector('.yotpo-btn-atc').textContent='ADD TO CART';
          parentWrapper.querySelector('.yotpo-btn-atc').removeAttribute('disabled');
        }
      }
  });
  function yotpoVariantStructure(productid, event) {
    var $mainBox = $('.yotpo-lightbox-container.yotpo-active-display .yotpo-lightbox-product[data-product-id="'+productid+'"]');
        $('.yotpo-variant-container').remove();
    var firstAnchorWithHref = $mainBox.find('a[href]').filter(function() {
    return $(this).attr('href').trim() !== '';
    }).first();
    var productUrl = firstAnchorWithHref.attr('href').split('?')[0] + '?section_id=yotpo-product-details';
        var $variantContainer = $('<div>', { class: 'yotpo-variant-container' });

        if (window.innerWidth > 767) {
            $mainBox.find('.yotpo-lightbox-product-details').append($variantContainer);
        } else {
            $mainBox.append($variantContainer);
        }
        $.get(productUrl, function(data) {
          var $tempDiv = $('<div>').html(data);
           $mainBox.each(function(){
            $(this).find('.yotpo-variant-container').append($tempDiv.find('.yotpoProductDetails').clone(true));
          })
            
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error('Error fetching JSON:', textStatus, errorThrown);
        });
}
  function yotpoAddToCart(variantId, quantity) {
    const url = '/cart/add.js';
    const data = {
        items: [{
            id: variantId,
            quantity: quantity
        }]
    };
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            $('.yotpo-close-modal:visible,.close-btn').click();
              refreshCart(cart);
              if($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }
              if($('#header').is(':visible')) {
                $('#header .cart-container').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart-container').addClass('active_link');
              } else {
                $('.top-bar .cart-container').addClass('active_link');
              }
          }
        });
    })
    .catch(error => {
        console.error('Error adding product to cart:', error);
    });
  }
});
/* Enavi User Journey Change */

/* Enavi Quick Filters */
document.addEventListener("DOMContentLoaded", function() {
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    const filterDropdowns = document.querySelectorAll('.filter-dropdown');
    const openFilterButtons = document.querySelectorAll('.open-filter');
    
    // Check if click is outside any filter dropdown and not on a filter button
    const isClickOutside = !event.target.closest('.filter-dropdown') && 
                          !event.target.closest('.open-filter');
    
    if (isClickOutside) {
      // Close all open dropdowns
      filterDropdowns.forEach(dropdown => {
        dropdown.closest('.filter-option-wrapper').classList.remove('filter-open');
      });
    }
  });

  document.querySelectorAll('.open-filter').forEach(button => {
    button.addEventListener('click', function() {
      const parent = this.closest('.filter-option-wrapper');
      document.querySelectorAll('.filter-option-wrapper').forEach(wrapper => {
        if (wrapper !== parent) {
          wrapper.classList.remove('filter-open');
        }
      });
      parent.classList.toggle('filter-open');
    });
  });

  $('.enavi-filter-inner input').change(function(){
    $(this).closest('.filter-dropdown-inner').find('.apply-filter,.clear-filter').removeClass('disabled')
  })

  $('.apply-filter').click(function(){
    let final_query_parameters = '';
    $('.enavi-filter-inner input:checked').each(function(i){
      if(i < $('.enavi-filter-inner input:checked').length-1){
        final_query_parameters+=$(this).attr('data-param')+'='+$(this).attr('value')+'&';
      }
      else{
        final_query_parameters+=$(this).attr('data-param')+'='+$(this).attr('value')
      }
    })
    
    let currentFilterUrL = new URL(window.location.href);
    let currentUrlParams = new URLSearchParams(currentFilterUrL.search);
    
    var finalURL = window.location.href.split('?')[0]+'?'+final_query_parameters.replace(/#/g, '');
    if (currentUrlParams.has('view')) {
      finalURL += '&view=' + currentUrlParams.get('view');
    }
    if (currentUrlParams.has('sort')) {
      finalURL += '&sort_by=' + currentUrlParams.get('sort_by');
    }   

    // Close the dropdown before making the AJAX call
    $(this).closest('.filter-option-wrapper').removeClass('filter-open');

    // Instead of reloading the page, use AJAX to update the content
    $.ajax({
      type: 'GET',
      url: finalURL,
      beforeSend: function() {
        $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
        Waypoint.destroyAll();
      },
      success: function(data) {
        $(".collection-matrix").removeClass('loading-in-progress');
        $(".collection-matrix").removeClass('filter-loading');
        
        // Update the collection matrix with new products
        var filteredData = $(data).find('.collection-matrix');
        $('.collection-matrix').remove();
        filteredData.insertBefore( $('.load-more__icon') );
        
        // Update URL without reloading
        window.history && window.history.pushState && window.history.pushState("", "", finalURL);
        
        // Reinitialize any necessary plugins or features
        if (Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges){
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
        if (Currency.show_multiple_currencies) {
          currencyConverter.convertCurrencies();
        }
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        productPage.init();
        if (Shopify.theme_settings.quick_shop_enabled) {
          quickShop.init();
        }
        hideNoScript();
        videoFeature.init();
        if (Shopify.theme_settings.collection_secondary_image){
          imageFunctions.showSecondaryImage();
        }

        // Reinitialize infinite scroll if enabled
        if (Shopify.theme_settings.pagination_type == 'infinite_scroll') {
          enableInfiniteScroll();
        }
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + finalURL);
      },
      dataType: "html"
    });
  })

  $('.clear-filter').click(function() {
    // Uncheck all checkboxes in the current filter dropdown
    $(this).closest('.filter-dropdown-inner').find('input[type="checkbox"]').prop('checked', false);
    
    let final_query_parameters = '';
    $('.filter-dropdown-inner').not((this).closest('.filter-dropdown-inner')).find('input:checked').each(function(i) {
      if(i < $('.enavi-filter-inner input:checked').length-1){
        final_query_parameters+=$(this).attr('data-param')+'='+$(this).attr('value')+'&';
      }
      else{
        final_query_parameters+=$(this).attr('data-param')+'='+$(this).attr('value')
      }
    });
    
    let currentFilterUrL = new URL(window.location.href);
    let currentUrlParams = new URLSearchParams(currentFilterUrL.search);
    
    var finalURL = window.location.href.split('?')[0]+'?'+final_query_parameters.replace(/#/g, '');
    if (currentUrlParams.has('view')) {
      finalURL += '&view=' + currentUrlParams.get('view');
    }
    if (currentUrlParams.has('sort')) {
      finalURL += '&sort_by=' + currentUrlParams.get('sort_by');
    }   

    // Instead of reloading the page, use AJAX to update the content
    $.ajax({
      type: 'GET',
      url: finalURL,
      beforeSend: function() {
        $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
        Waypoint.destroyAll();
      },
      success: function(data) {
        $(".collection-matrix").removeClass('loading-in-progress');
        $(".collection-matrix").removeClass('filter-loading');
        
        // Update the collection matrix with new products
        var filteredData = $(data).find('.collection-matrix');
        $('.collection-matrix').remove();
        filteredData.insertBefore( $('.load-more__icon') );
        
        // Update URL without reloading
        window.history && window.history.pushState && window.history.pushState("", "", finalURL);
        
        // Reinitialize any necessary plugins or features
        if (Shopify.theme_settings.enable_shopify_review_comments && Shopify.theme_settings.enable_shopify_collection_badges){
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
        if (Currency.show_multiple_currencies) {
          currencyConverter.convertCurrencies();
        }
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        productPage.init();
        if (Shopify.theme_settings.quick_shop_enabled) {
          quickShop.init();
        }
        hideNoScript();
        videoFeature.init();
        if (Shopify.theme_settings.collection_secondary_image){
          imageFunctions.showSecondaryImage();
        }

        // Reinitialize infinite scroll if enabled
        if (Shopify.theme_settings.pagination_type == 'infinite_scroll') {
          enableInfiniteScroll();
        }
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + finalURL);
      },
      dataType: "html"
    });
  });
})
/* Enavi Quick Filters */

/* Popup when 2 same size frame added */
function initCheckoutInterception() {
  const buttons = document.querySelectorAll('#nvd-with-checkout-btn, #nvd-without-checkout-btn, [name="checkout"]');
  if (!buttons.length) return;

  buttons.forEach(btn => {
    if (btn.dataset.listenerAdded) return; // Prevent double-binding
    btn.dataset.listenerAdded = "true";

    btn.addEventListener("click", (e) => {
      if (btn.dataset.bypassPopup === "true") return; // Let it pass on second click

      e.preventDefault();
      e.stopImmediatePropagation();

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          return Promise.all(
            cart.items.map(item =>
              fetch(`/products/${item.handle}.js`)
                .then(res => res.json())
                .then(prod => ({
                  item,
                  handle: item.handle,
                  tags: prod.tags
                }))
            )
          );
        })
        .then(items => {
          const relevant = items.filter(p => p.tags.includes("deco tv frame"));

          const sizeMap = {};
          relevant.forEach(({ item, handle }) => {
            const size = item.options_with_values.find(opt =>
              ["to fit diagonal tv size", "size"].includes(opt.name.toLowerCase())
            )?.value;
          
            const modelYear = item.options_with_values.find(opt =>
              opt.name === "Samsung Frame TV Model Year"
            )?.value;
          
            const key = `${size}___${modelYear}`;
            if (!sizeMap[key]) sizeMap[key] = new Set();
            sizeMap[key].add(handle);
          });

          const conflict = Object.values(sizeMap).some(set => set.size > 1);
          if (conflict) {
            showFramePopup(() => {
              btn.dataset.bypassPopup = "true"; // Allow next click
              btn.click(); // Trigger real Navidium checkout logic
            });
            return;
          }

          // No conflict, allow regular checkout
          btn.dataset.bypassPopup = "true";
          btn.click();
        });
    });
  });
}

function showFramePopup(onContinue) {
  if (document.getElementById("frame-warning-popup")) return;

  const popup = document.createElement("div");
  popup.id = "frame-warning-popup";
  popup.className = "buy2-popup-overlay";
  popup.innerHTML = `
    <div class="buy2-popup">
      <h3>Undecided? Totally Normal.</h3>
      <p>
        If you’re torn between styles, ordering both just to return one adds waste and delay. Skip the hassle—our customer service team can send <strong>up to three free samples</strong> to help you choose the perfect showstopper! Just chat, call, or email us.
      </p>
      <p>Chasing a promo? Ask us to flag your account so you don’t miss the deal.</p>
      <p>Framing two TVs? Awesome—carry on, and thank you for supporting Made in America!</p>
      <div class="buy2-popup-actions">
        <button id="continueCheckoutBtn" class="buy2-popup-btn">Continue to Checkout</button>
        <button class="buy2-popup-cancel">Cancel</button>
      </div>
    </div>`;

  document.body.appendChild(popup);

  document.getElementById("continueCheckoutBtn")
    .addEventListener("click", () => {
      popup.remove();
      onContinue();
    });

  document.querySelector(".buy2-popup-cancel")
    .addEventListener("click", () => {
      popup.remove();
    });
}



// Start observing when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initCheckoutInterception();

  const observer = new MutationObserver(() => {
    initCheckoutInterception();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


/* Popup when 2 same size frame added */

/* Hubspot Serial Number Prepopulate JS */
document.addEventListener('DOMContentLoaded', function() {
    // Function to get URL parameter value by name
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Get the serial number parameter value from URL
    var serialNumber = getUrlParameter('sr');
    console.log(serialNumber);
    // Set the serial number as the default value for the form field
    const formField = document.querySelector('input[name="serial_number"]');
    if (formField) {
      formField.value = serialNumber;
    }
});

/* Enavi Model Selector */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.other-model-dropdown').addEventListener('change', function(event) {
    const selectedValue = event.target.value;
    document.querySelector('[for="other-model-dropdown"]').textContent = selectedValue;
    if(selectedValue == 'other'){
    document.querySelector('.other-model-popup').style.display = 'block';
    document.body.classList.add('modal-open');
    }
    else if (selectedValue === '2017-2020 Frame TV') {
      const legacyUrl = document.querySelector('.other-model-dropdown').dataset.legacyUrl;
      if (legacyUrl) {
        window.location.href = legacyUrl;
      } else {
        window.location.href = '/collections/legacy-frames';
      }
    }
  });
  document.querySelector('.model-close').addEventListener('click', function(event) {
    document.querySelector('.other-model-popup').style.display = 'none';
    document.body.classList.remove('modal-open');
  })
})
/* Enavi Model Selector */

/* Enavi Mobile Adjustments on PDP */
document.addEventListener('DOMContentLoaded', function() {
    // Select elements to move
    const productName = document.querySelector(".product_section .product_name");
    const modalPrice = document.querySelector(".product_section .modal_price");
    const yotpoWidget = document.querySelector(".product_section .yotpo-widget-instance");
    const galleryWrap = document.querySelector(".gallery-wrap");

    // Move elements to enavi wrapper only if screen width is <= 798px
    if (window.innerWidth <= 798) {
        if (!document.querySelector(".enavi-elements-wrapper") && productName && modalPrice && yotpoWidget && galleryWrap) {
            // Create a wrapper div
            const wrapperDiv = document.createElement("div");
            wrapperDiv.classList.add("enavi-elements-wrapper"); // Class for styling

            // Create a div for product name and price (inline container)
            const namePriceWrapper = document.createElement("div");
            namePriceWrapper.classList.add("name-price-wrapper"); // Class for styling

            // Append product name and price inside the inline container
            namePriceWrapper.appendChild(productName);
            namePriceWrapper.appendChild(modalPrice);

            // Append name-price wrapper and Yotpo widget to the main wrapper
            wrapperDiv.appendChild(namePriceWrapper);
            wrapperDiv.appendChild(yotpoWidget);

            // Insert wrapper before the first child of .gallery-wrap
            galleryWrap.insertBefore(wrapperDiv, galleryWrap.firstChild);
        }
    }
});
/* Mobile Adjustments on PDP */

/* Legacy Frames add to cart popup  */

document.addEventListener('DOMContentLoaded', function () {
    const legacyButton = document.querySelector('[data-popup-trigger="legacy-popup"]');
    const popup = document.getElementById('legacy-popup');
    const closeBtn = popup?.querySelector('.close-btn');
    const confirmBtn = document.getElementById('confirm-legacy');
    const initialsInput = document.getElementById('legacy-initials');
    const form = legacyButton?.closest('form');

    if (legacyButton && popup && confirmBtn && initialsInput && form) {
      // Block ALL Add to Cart attempts for legacy item before confirming
      legacyButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Important: stop other theme scripts!
        popup.style.display = 'flex';
      });

      closeBtn?.addEventListener('click', () => popup.style.display = 'none');

      initialsInput.addEventListener('input', () => {
        confirmBtn.disabled = initialsInput.value.trim().length === 0;
      });

      confirmBtn.addEventListener('click', function () {
        const initials = initialsInput.value.trim();
        if (initials) {
          // Add initials to form as a hidden line item property
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = 'properties[Non-returnable policy accepted by]';
          hiddenField.value = initials;
          form.appendChild(hiddenField);

          // Close popup and submit form
          popup.style.display = 'none';
          form.submit(); // triggers normal Shopify behavior
        }
      });

      // Optional: click outside popup to close
      popup.addEventListener('click', function (e) {
        if (e.target === popup) {
          popup.style.display = 'none';
        }
      });
    }
  });

/* Legacy Frames add to cart popup  */  

/* OPEN BOX confirmation popup*/

  document.addEventListener('DOMContentLoaded', function () {
    const openboxButton = document.querySelector('[data-popup-trigger="open-box-popup"]');
    const popup = document.getElementById('open-box-popup');
    const closeBtn = popup?.querySelector('.close-btn');
    const confirmBtn = document.getElementById('confirm-open-box');
    const initialsInput = document.getElementById('open-box-initials');
    const form = openboxButton?.closest('form');

    if (openboxButton && popup && confirmBtn && initialsInput && form) {
      // Block ALL Add to Cart attempts for open box item before confirming
      openboxButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Important: stop other theme scripts!
        popup.style.display = 'flex';
      });

      closeBtn?.addEventListener('click', () => popup.style.display = 'none');

      initialsInput.addEventListener('input', () => {
        confirmBtn.disabled = initialsInput.value.trim().length === 0;
      });

      confirmBtn.addEventListener('click', function () {
        const initials = initialsInput.value.trim();
        if (initials) {
          // Add initials to form as a hidden line item property
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = 'properties[Non-returnable policy accepted by]';
          hiddenField.value = initials;
          form.appendChild(hiddenField);

          // Close popup and submit form
          popup.style.display = 'none';
          form.submit(); // triggers normal Shopify behavior
        }
      });

      // Optional: click outside popup to close
      popup.addEventListener('click', function (e) {
        if (e.target === popup) {
          popup.style.display = 'none';
        }
      });
    }
  });

/* OPEN BOX confirmation popup*/

/* PDP-Sticky Nav */
(function () {
  const MOBILE_BREAKPOINT = 768;
  let navOffset = 60;
  let currentSticky = null;
  let anchorNavs = [];

  const rootStyle = document.documentElement.style;

  // Pick correct nav element for current viewport
  const getMainNav = () =>
    document.querySelector(
      window.innerWidth <= MOBILE_BREAKPOINT ? '#header' : '.main-nav__wrapper'
    );

  // Calculate combined nav + epb height and set CSS var
  function calculateNavOffset() {
    const mainNav = getMainNav();
    const epb = document.querySelector('#epb_container');

    const totalHeight =
      (mainNav?.offsetHeight || 0) + (epb?.offsetHeight || 0) || 60;

    navOffset = totalHeight;
    rootStyle.setProperty('--nav-offset', `${navOffset}px`);
  }

  // Sticky handler (no stop element needed anymore)
  function handleStickyNav() {
    // Find last anchor-nav above navOffset
    let newSticky = null;
    for (const nav of anchorNavs) {
      const wrapper =
        nav.closest('.anchor-nav-wrapper') || nav.parentElement || nav;
      if (wrapper.getBoundingClientRect().top <= navOffset) {
        newSticky = nav;
      }
    }

    // Switch sticky
    if (newSticky !== currentSticky) {
      currentSticky?.classList.remove('sticky');
      newSticky?.classList.add('sticky');
      currentSticky = newSticky;
    }

    // Remove sticky if scrolled above current wrapper
    if (currentSticky) {
      const wrapper =
        currentSticky.closest('.anchor-nav-wrapper') ||
        currentSticky.parentElement ||
        currentSticky;
      if (wrapper.getBoundingClientRect().top > navOffset) {
        currentSticky.classList.remove('sticky');
        currentSticky = null;
      }
    }
  }

  // Init
  function init() {
    anchorNavs = [...document.querySelectorAll('.anchor-nav')];

    calculateNavOffset();

    // Recalc offset when nav or epb resize
    const ro = new ResizeObserver(() =>
      requestAnimationFrame(calculateNavOffset)
    );
    const mainNav = getMainNav();
    if (mainNav) ro.observe(mainNav);
    const epb = document.querySelector('#epb_container');
    if (epb) ro.observe(epb);

    // Global scroll + resize listeners
    window.addEventListener('scroll', handleStickyNav, { passive: true });
    window.addEventListener('resize', () => {
      calculateNavOffset();
      handleStickyNav();
    });

    // Run once
    handleStickyNav();

    // Active state for clicked anchor links
    document.querySelectorAll('.anchor-nav a').forEach((link) => {
      link.addEventListener('click', (e) => {
        document
          .querySelectorAll('.anchor-nav a.active')
          .forEach((a) => a.classList.remove('active'));
        link.classList.add('active');
      });
    });
  }

  init();
})();

/* PDP-Sticky Nav */

/* View Specs Below Size Selector */
document.addEventListener("DOMContentLoaded", function() {
  const specLink = document.querySelector('[href="#specifications"]');
  const viewLink = document.querySelector('.specification-link')
  if (specLink) {
    viewLink.addEventListener('click', function () {
        const table = document.querySelector('#specifications table');
            if (table) {
                const offset = window.innerWidth <= 768?170:300;
                const top = table.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        });
  }

  function buildFrameSizesFromTable() {
    const table = document.querySelector('#specifications table, #specifications');
    if (!table) return {};
    const rows = table.querySelectorAll('tr');
    const FRAME_SIZES = {};
    rows.forEach(function(row, index) {
      if (index === 0) return;
      const cols = row.querySelectorAll('td');
      if (cols.length < 3) return;
      var sizeRaw = cols[0].innerText.trim();
      var widthRaw = cols[1].innerText.trim();
      var heightRaw = cols[2].innerText.trim();
      var size = sizeRaw.replace(/"/g, '').trim();
      if (!size || !widthRaw || !heightRaw) return;
      FRAME_SIZES[size] = { frameWidth: widthRaw, frameHeight: heightRaw };
    });
    return FRAME_SIZES;
  }

  // Build once — now runs on ALL devices, not just desktop
  var FRAME_SIZES = buildFrameSizesFromTable();
  window.FRAME_SIZES = FRAME_SIZES; // expose so popup markup/other scripts can read it

  function updatePopupDims(size) {
    var dimsEl = document.getElementById('size-98-dims');
    var dims = FRAME_SIZES[size];
    if (!dimsEl || !dims) return;
    dimsEl.textContent = dims.frameWidth + ' x ' + dims.frameHeight;
  }

  function getSelectedSizeFromWrapper(wrapper) {
    var inputs = wrapper.querySelectorAll('input.size-option');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return inputs[i].value.replace(/"/g, '');
    }
    return null;
  }

  var swatchWrapper = document.querySelector('.swatch[data-option-index="0"]');
  if (swatchWrapper) {
    // Update popup dims on load + on every size change (works on mobile too)
    setTimeout(function() {
      var initial = getSelectedSizeFromWrapper(swatchWrapper);
      if (initial) updatePopupDims(initial);
    }, 0);

    swatchWrapper.addEventListener('change', function(e) {
      if (!e.target.classList.contains('size-option')) return;
      var size = e.target.value.replace(/"/g, '');
      updatePopupDims(size);
    });
  }

  /* 61-1-R-PDP-Specs Below Size Selector — Desktop Only */
  if (window.innerWidth <= 798 || !swatchWrapper || Object.keys(FRAME_SIZES).length === 0) return;

  var specsEl = document.querySelector('.frame-specs');
  if (!specsEl) return;

  function updateFrameSpecs(size) {
    if (!FRAME_SIZES[size]) {
      specsEl.innerHTML = '';
      return;
    }
    var dims = FRAME_SIZES[size];
    specsEl.innerHTML =
      '<span><b>Frame Width</b>: ' + dims.frameWidth + '</span>' +
      '<span><b>Frame Height</b>: ' + dims.frameHeight + '</span>';
  }

  setTimeout(function() {
    var initialSize = getSelectedSizeFromWrapper(swatchWrapper);
    if (initialSize) updateFrameSpecs(initialSize);
  }, 0);

  swatchWrapper.addEventListener('change', function(e) {
    if (!e.target.classList.contains('size-option')) return;
    var size = e.target.value.replace(/"/g, '');
    updateFrameSpecs(size);
    var existingNote = specsEl.nextElementSibling;
    if (existingNote && existingNote.classList.contains('size-98-note')) {
      existingNote.remove();
    }
    if (parseInt(size, 10) === 98) {
      var noteEl = document.createElement('div');
      noteEl.className = 'size-98-note';
      noteEl.innerHTML =
        '<br><div class="alert-warning">98" frames are made-to-order and will ship within 3-4 business days.</div>';
      specsEl.insertAdjacentElement('afterend', noteEl);
    }
  });
});
/* View Specs Below Size Selector */
 
/* Coupon discount Badge PDP */

window.applyDiscountBadge = function(product, variant, code, percent, activeFixed, fixed, min) {
  console.log(code);
  let $product = $(product);
  if ($product.find('.custom_discount_info').length > 0) {
    let discount_percent = parseInt(percent) / 100;

    if (activeFixed == "true" || activeFixed === true) {
      let discount_price = parseInt(fixed) * 100;
      let min_price = parseInt(min) * 100;

      if (variant.price >= min_price) {
        $product.find('.discounted_amount').html(
          Shopify.formatMoney(variant.price - discount_price, $('body').data('money-format'))
        ).removeClass('hidden');
        $product.find('.current_price').addClass('was_price');
      } else {
        // 👇 reset if below min
        $product.find('.discounted_amount').html('').addClass('hidden');
        $product.find('.current_price').removeClass('was_price');
      }
    } else {
      $product.find('.discounted_amount').html(
        Shopify.formatMoney(variant.price * (1 - discount_percent), $('body').data('money-format'))
      ).removeClass('hidden');
      $product.find('.current_price').addClass('was_price');
    }

    $product.find('.discount_code_box').addClass('active');
  }
};

  /* Coupon discount Badge PDP */

  /* Fixing FBT Duplicate issue */

  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        const containers = document.querySelectorAll('.cbb-frequently-bought-container');
        if (containers.length > 1) {
            containers.forEach((el, index) => {
                if (index < containers.length - 1) el.remove();
            });
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        const containers = document.querySelectorAll('.review-section-wrapper');
        if (containers.length > 1) {
            containers.forEach((el, index) => {
                if (index < containers.length - 1) el.remove();
            });
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

/* Fixing FBT Duplicate issue */

/* Enavi UVP Icons */
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.auto-scroll-container');
  if (!container) return;

  const track = container.querySelector('.auto-scroll-track');
  if (!track) return;

  if (window.innerWidth <= 768) {
    // Duplicate all items once for seamless loop
    const items = Array.from(track.children);
    items.forEach(el => {
      track.appendChild(el.cloneNode(true));
    });
  } else {
    container.classList.add('container');
  }
});
/* Enavi UVP Icons */

/* Sale badge on product scroll */
document.addEventListener("DOMContentLoaded", function () {
  const productContainer = document.querySelector('.product-list');

  function applyCustomMods() {
    const activeBoxes = document.querySelectorAll('.discount_code_box_plp.active');

    if (activeBoxes.length > 0) {
      $('.discount_code_box_plp').addClass('active');
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('.four.columns')) {
          applyCustomMods();
        }
      });
    });
  });

  observer.observe(productContainer, { childList: true, subtree: true });
});

/* Sale badge on product scroll */

/* 53-1-R-PDP-Variant Selector */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.frame-type-label').forEach(label => {
      label.addEventListener('click', () => {
          // Toggle class on the clicked label
          label.classList.toggle('active');

          // Toggle the next .frame-type-options
          const next = label.nextElementSibling;
          if (next && next.classList.contains('frame-type-options')) {
          next.classList.toggle('open');
          next.style.display = next.style.display === 'block' ? 'none' : 'block';
          }
      });
  });
})
/* 53-1-R-PDP-Variant Selector */

/* PDP dealer alert */
document.addEventListener("DOMContentLoaded", function() {
    const idHolder = document.getElementById("dealer-pricing-alert");
    if (!idHolder) return;
    const customerId = idHolder.dataset.customerId;
  fetch("https://decoapi.framemytv.com/api/fmtv/customer/is-reseller/?customerid=" + customerId)
    .then(res => res.json())
    .then(data => {
      if (data.isReseller === true) {
        document.getElementById("dealer-pricing-alert").style.display = "block";
      }
    })
    .catch(err => console.error(err));

});
/* PDP dealer alert  */
document.addEventListener("DOMContentLoaded", function() {
  if(!window.location.pathname.indexOf('/products/') && window.innerWidth > 768){
    return;
  }
  const GALLERY_SELECTOR = '.yotpo-pictures-widget .yotpo-slider-wrapper';
  const INSERT_AFTER_SELECTOR = '.samsung-img';
  const CUSTOM_WRAPPER_CLASS = 'custom-yotpo-preview-wrapper';
  const PREVIEW_CLASS = 'custom-yotpo-preview';
  const POPUP_CLASS = 'yotpo-custom-popup';

  function initCustomYotpoPreview() {
    const gallery = document.querySelector(GALLERY_SELECTOR);
    const insertAfterEl = document.querySelector(INSERT_AFTER_SELECTOR);
    if (!gallery || !insertAfterEl) return;

    // Prevent duplicate
    if (document.querySelector(`.${CUSTOM_WRAPPER_CLASS}`)) return;

    const images = gallery.querySelectorAll('[data-src]');
    if (!images.length) return;

    const totalImages = images.length;
    const totalVisibleCount = window.innerWidth >= 769?7:4
    const previewImages = Array.from(images).slice(0, totalVisibleCount);

    /* ===== Outer wrapper ===== */
    const outerWrapper = document.createElement('div');
    outerWrapper.className = CUSTOM_WRAPPER_CLASS;

    /* ===== Header (Heading + View All) ===== */
    const header = document.createElement('div');
    header.className = 'custom-yotpo-header';

    const heading = document.createElement('h3');
    heading.className = 'custom-yotpo-heading';
    heading.textContent = 'See it in Real Homes';

    const viewAllBtn = document.createElement('button');
    viewAllBtn.className = 'custom-yotpo-view-all';
    viewAllBtn.textContent = 'View all →';
    viewAllBtn.addEventListener('click', openYotpoPopup);

    header.appendChild(heading);
    header.appendChild(viewAllBtn);

    /* ===== Preview grid ===== */
    const previewWrapper = document.createElement('div');
    previewWrapper.className = PREVIEW_CLASS;

    previewImages.forEach(img => {
      const imgWrap = document.createElement('div');
      imgWrap.className = 'custom-yotpo-img';

      const image = document.createElement('img');
      image.src = img.getAttribute('data-src');
      imgWrap.setAttribute('data-image-id',img.getAttribute('data-image-id'))
      image.alt = img.alt || '';

      imgWrap.appendChild(image);
       imgWrap.addEventListener('click', function () {
        const targetEl = document.querySelector(
        `[data-external-image-id="${imgWrap.getAttribute('data-image-id')}"]`
        );
        if (!targetEl) return;
        const nextSibling = targetEl.nextElementSibling;
        if (nextSibling) {
            nextSibling.click();
            setTimeout(function(){
              const el = document.querySelector('.yotpo-lightbox-product-selected');
              const touchEndEvent = new TouchEvent('touchend', {
                bubbles: true,
                cancelable: true,
                touches: [],
                targetTouches: [],
                changedTouches: [
                  new Touch({
                    identifier: Date.now(),
                    target: el,
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0,
                    screenX: 0,
                    screenY: 0
                  })
                ]
              });
              el.dispatchEvent(touchEndEvent);
            },1000)
        }
    });
      previewWrapper.appendChild(imgWrap);
    });

    /* ===== +X more overlay ===== */
    if (totalImages > totalVisibleCount) {
      const moreCount = totalImages - totalVisibleCount;

      const overlay = document.createElement('div');
      overlay.className = 'custom-yotpo-more';
      overlay.innerHTML = `<span>+${moreCount} more</span>`;
      overlay.addEventListener('click', openYotpoPopup);

      previewWrapper.lastElementChild.appendChild(overlay);
    }

    /* ===== Assemble ===== */
    outerWrapper.appendChild(header);
    outerWrapper.appendChild(previewWrapper);

    // Insert AFTER .samsung-img
    insertAfterEl.insertAdjacentElement('afterend', outerWrapper);
  }
  function openYotpoPopup() {
    const popup = document.querySelector(`.${POPUP_CLASS}`);
    if (popup) {
      popup.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }
  // Wait for Yotpo async load
  const yotpoInterval = setInterval(() => {
    const gallery = document.querySelector(GALLERY_SELECTOR);
    //console.log(gallery.querySelectorAll('.yotpo-single-image-container').length)
    if (gallery && gallery.querySelectorAll('.yotpo-single-image-container').length != 0) {
      initCustomYotpoPreview();
      clearInterval(yotpoInterval);
      document.body.classList.add('real-widget-loaded')
    }
  }, 2000);
  const popup = document.querySelector(`.${POPUP_CLASS}`);
  function closeYotpoPopup() {
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  const closeBtn = popup.querySelector('.close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeYotpoPopup);
  }
  popup.addEventListener('click', function (e) {
    const popupContent = popup.querySelector('.yotpo-popup-inner');
    if (!popupContent) return;

    if (!popupContent.contains(e.target)) {
      closeYotpoPopup();
    }
  });
})

/* Stop redirect to cart page */

$(document).on('submit', 'form[action="/cart/add"]', function(e){
  if ($(this).find('.ajax-submit').length) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
});

/* Stop redirect to cart page */

/* Free shipping popup */

document.addEventListener("click", function(e){

  if(e.target.classList.contains("learn-more-trigger")){
    document.getElementById("learnMorePopup").style.display = "flex";
  }

  if(e.target.classList.contains("learnmore-popup-close")){
    document.getElementById("learnMorePopup").style.display = "none";
  }

  if(e.target.id === "learnMorePopup"){
    document.getElementById("learnMorePopup").style.display = "none";
  }

});

/* Free shipping popup */

/* Applying order tags to users bucketed into convert tests */
window.addEventListener("load", () => {
  if (window.convert) {
    try {
      const experiences =
        !!window.convert.hasOwnProperty("currentData") &&
        window.convert.currentData.experiences;

      if (experiences) {
        for (const experienceId in experiences) {
          const experience = experiences[experienceId];

          const formData = new FormData();
          const orderTag = `Convert-${experienceId}-${experience.variation.id}`;

          formData.append("attributes[Convert Experience ID]", experienceId);
          formData.append(
            "attributes[Convert Variation Key]",
            experience.variation.key
          );
          formData.append("attributes[Convert Order Tag]", orderTag);

          fetch("/cart/update.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Convert experiment logged to cart", orderTag);
            });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
});
/* Applying order tags to users bucketed into convert tests */

/* 98" size confirmation popup */

document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('size-98-popup');
  const closeBtn = popup?.querySelector('.close-btn');
  const confirmBtn = document.getElementById('confirm-size-98');
  const initialsInput = document.getElementById('size-98-initials');

  document.querySelectorAll('[data-product-form]').forEach(function (formWrapper) {
    const button = formWrapper.querySelector('#AddToCart');
    const form = button?.closest('form');
    const idField = form?.querySelector('[name="id"]');
    if (!popup || !button || !confirmBtn || !initialsInput || !form || !idField) return;

    let productData;
    try {
      productData = JSON.parse(formWrapper.dataset.product);
    } catch (err) {
      return;
    }

    function isSize98Selected() {
      const variantId = parseInt(idField.value, 10);
      const variant = productData.variants.find(v => v.id === variantId);
      if (!variant) return false;
      return [variant.option1, variant.option2, variant.option3].includes('98"');
    }

    button.addEventListener('click', function (e) {
      if (!isSize98Selected()) return; // not the 98" variant, let normal flow proceed
      e.preventDefault();
      e.stopImmediatePropagation();
      popup.style.display = 'flex';
    });
  });

  closeBtn?.addEventListener('click', () => popup.style.display = 'none');

  initialsInput.addEventListener('input', () => {
    confirmBtn.disabled = initialsInput.value.trim().length === 0;
  });

  confirmBtn.addEventListener('click', function () {
    const initials = initialsInput.value.trim();
    if (!initials) return;
    const activeForm = document.querySelector('#AddToCart')?.closest('form');
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = 'properties[Restocking fee policy accepted by]';
    hiddenField.value = initials;
    activeForm.appendChild(hiddenField);
    popup.style.display = 'none';
    activeForm.submit();
  });

  popup.addEventListener('click', function (e) {
    if (e.target === popup) popup.style.display = 'none';
  });
});

/* 98" size confirmation popup */